import React, {useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import './styles.scss';
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../../store/reducers";
import {AppointmentsState} from "../../../store/reducers/appointments";
import {loadMyTodo} from "../../../store/actions/appointments";
import {TodoRow, Appointment} from "../../../services/dto/Common";
import AuthService from '../../../services/authService';
import { Box, Checkbox, FormControl, FormControlLabel, Paper, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { getRecordId } from '@utils/helpers';

export const ToDo = () => {
  const {myTodo, appointments} = useSelector<IAppState, AppointmentsState>(s => s.appointments)
  const [nearestApt, setNearestApt] = useState<Appointment>();
  const dispatch = useDispatch();
  const { user } = AuthService.getAuth();
  const history = useHistory();
  useEffect(() => {
    dispatch(loadMyTodo())
  }, [])

  useEffect(() => {
    const items = (appointments.data || []).filter((i) => i.status);
    setNearestApt(items[0])
  }, [appointments]);

  const renderLabel = (item: TodoRow) => {
    const ret = {
      title: item.title,
      link: '#',
      body: ''
    }

    switch (item.type) {
      case 'creditCard':
        ret.body = "This is needed in case there are any copays or deductibles associated with your insurance coverage and to account for our no-show policy in case of a missed appointment.";
        ret.link = 'profile?step=payment';
        break;
      case 'insurance':
        ret.body = "We are missing information or you haven't uploaded a photo of your insurance card. We need this to verify your coverage for Ognomy appointments and assessments.";
        ret.link = `profile?step=insurance`;
        break;
      case 'newForms':
        ret.body = "This information allows the sleep specialist to design a tailored treatment plan best suited to your needs.";
        ret.link = !item.completed ? 'forms?formType=newPatient' : '#';
        break;
      case 'followUpForms':
        ret.body = "It may take a few days to show complete, as we need to approve them on our end.";
        ret.link = !item.completed ? `forms?formType=followUp&appointmentId=${item.appointmentId}` : '#';
        break;
      case 'weightManagementForms':
        ret.body = "Answering these questions will help your sleep specialist design a tailored treatment plan best suited to your needs.";
        ret.link = !item.completed ? `forms?formType=weightManagement&therapyId=${item.therapyId}` : '#';
        break;
      case 'weightManagementFollowUpForms':
        ret.body = "Answering these questions will help your sleep specialist design a tailored treatment plan best suited to your needs.";
        ret.link = !item.completed ? `forms?formType=wmFollowUp&therapyId=${item.therapyId}&appointmentId=${item.appointmentId}` : '#';
        break;
      default:
        break;
    }

    return ret;
  }

  const renderContent = () => {
    if (!myTodo.data) return null

    return <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', overflowY: 'auto', maxHeight: '440px' }}>
        {myTodo.data.items.map((item, index) => (
          <FormControlLabel
            key={index}
            sx={{ '&:hover': { cursor: item.completed ? 'default' : 'pointer' } }}
            onClick={() => history.push(renderLabel(item).link)}
            control={
              <Checkbox
                checked={item.completed}
                id={`check-${index}`}
                onChange={_.noop}
                disabled={true}
              />
            }
            label={<Box sx={{ marginLeft: '16px' }}>
              <Typography variant="body1" color={item.completed ? 'inherit' : "text.primary"} fontWeight="bold">
                {renderLabel(item).title}
              </Typography>
              <Typography variant="body2" color={item.completed ? 'inherit' : "text.primary"}>
                {renderLabel(item).body}
              </Typography>
            </Box>}
          />
        ))}
      </Box>
    </>
  }
  return (
    <Paper elevation={0} style={{ padding: '22px 32px', height: '548px', marginBottom: '16px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" fontWeight="bold">To-Do</Typography>
          <Typography variant="h6" color="common.black">
            <span style={{ fontWeight: 'bold' }}>{myTodo.data?.items.filter(i => i.completed).length}</span>
            /{myTodo.data?.items.length} Completed
          </Typography>
        </Box>
        {myTodo.loading && <Typography variant="body2" color="common.black">Loading...</Typography>}
        {!myTodo.loading && (myTodo.err || !myTodo.data) && <Typography variant="body2" color="common.black">No data available</Typography>}
        {myTodo.data && renderContent()}
      </Box>
    </Paper>
  );
};

export default ToDo;
